var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokBlack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiktok_black",
    "data-name": "tiktok black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.676,
    height: 26.685,
    viewBox: "0 0 26.676 26.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok_black-2",
    "data-name": "tiktok black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14083",
    "data-name": "Path 14083",
    d: "M26.676,12.507v1.668c-.021.171-.045.342-.064.513a13.378,13.378,0,0,1-10.956,11.79c-.493.09-.993.139-1.49.207H12.5c-.171-.021-.341-.045-.512-.064a12.975,12.975,0,0,1-7.4-3.218A13.037,13.037,0,0,1,.062,12a12.649,12.649,0,0,1,3.27-7.48A13.063,13.063,0,0,1,13.108,0a12.662,12.662,0,0,1,7.07,1.889,13.149,13.149,0,0,1,6.293,9.148C26.561,11.526,26.609,12.018,26.676,12.507Zm-13-6.772V6.1q0,4.951,0,9.9c0,.156,0,.313-.02.468a2.255,2.255,0,0,1-4.483.048,2.212,2.212,0,0,1,1.7-2.435,6.105,6.105,0,0,1,1.238-.013v-2.55a14.045,14.045,0,0,0-1.571.1,4.7,4.7,0,0,0-3.808,5.567,4.779,4.779,0,0,0,5.817,3.639,4.729,4.729,0,0,0,3.636-4.655c0-1.711-.011-3.422-.017-5.133,0-.092,0-.184,0-.329A6.324,6.324,0,0,0,20,12V9.543a3.886,3.886,0,0,1-3.844-3.807Z",
    transform: "translate(0 0)",
    fill: "#ffd6ec"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktok_black.e46cacddcbb98c4d3e44a0cf62ca1745.svg";
export { ForwardRef as ReactComponent };